import { Locale } from 'modules/i18n';

export const bannerTranslation = {
  [Locale.en]: {
    text: 'Due to maintenance work, access to endpoints via IPv6 is temporarily unavailable.',
  },
};
